import moment from "moment";
class Expense {
  category = null;
  paymentmethod = null;
  amount = 0;
  date = null;
  file = null;
  note = null;

  createdby = null;
  updatedby = null;

  static getFormData(object, isPutMethod = false) {
    console.log("creating form data ....");
    const formData = new FormData();
    console.log(object.category);
    formData.append("category", object.category);
    formData.append("paymentmethod", object.paymentmethod);
    formData.append("moneyaccountid", object.moneyaccountid);
    formData.append("amount", object.amount);
    const date = moment(object.date).format("YYYY-MM-DD");
    formData.append("date", date);
    if (object.file) {
      formData.append("file", object.file);
    }
    formData.append("note", object.note ?? "");
    if (isPutMethod) {
      formData.append("_method", "PUT");
    }
    return formData;
  }
}

export default Expense;
